import type { AccessStateResponse } from '@assessments/shared'
import { useRemoteData } from '../../hooks/useRemoteData.js'
import { fetchAccessState } from './api.js'

export interface UseAccessState {
  data: AccessStateResponse | null
  /** True only until the first result; re-checks keep the current screen up. */
  loading: boolean
  /** Set when no result has ever arrived; a failed re-check keeps the last result. */
  error: string | null
  reload: () => void
  setData: (data: AccessStateResponse) => void
}

/**
 * The API guard, not this check, keeps content away from a deep link reached by in-app
 * navigation. A held result is never replaced by a loading or error state.
 */
export function useAccessState(): UseAccessState {
  const { data, error, reload, setData } = useRemoteData(fetchAccessState)
  return {
    data,
    loading: data === null && error === null,
    error: data === null ? error : null,
    reload,
    setData,
  }
}
